import React, {
  FC, useContext, useMemo, useState,
} from 'react';
import { ArticleListContext } from '../articleListContext';
import { IEditArticleDraftButton } from './types';
import { ClickableDiv } from 'components/base/ClickableDiv';
import CustomIcon from 'components/base/CustomIcon';
import { OtherTypes } from 'components/base/CustomIcon/types';
import { EditDraftModal } from 'components/pages/articles/editDraftModal';
import './index.scss';
import { ModifyOrderLine } from 'components/pages/articles/modifyOrderLineModal';
import { ArticleTrackingDtoStatus, OrderLine } from 'config/apiFunus/generated/data-contracts';

export const EditArticleDraftButton: FC<IEditArticleDraftButton> = (
  { articleId, onAccept, articleStatus },
) => {
  const [showEditModal, setshowEditModal] = useState<boolean>(false);
  const { infoProvidedFlowers } = useContext(ArticleListContext);

  const infoProvided = useMemo(() => infoProvidedFlowers.find(
    (providedInfo) => providedInfo.code === articleId,
  ), [articleId, infoProvidedFlowers]);

  const isInfoProvided = useMemo(() => !!infoProvided, [infoProvided]);

  return (
    <React.Fragment>
      <ClickableDiv
        className="invoice-edit-flowers-button"
        disabled={articleStatus !== ArticleTrackingDtoStatus.DRAFT}
        onClick={() => {
          setshowEditModal(true);
        }}
      >
        {isInfoProvided || articleStatus !== ArticleTrackingDtoStatus.DRAFT
          ? <CustomIcon icon={OtherTypes.BUDGET_ACCEPT} />
          : <CustomIcon icon={OtherTypes.EDIT} /> }
      </ClickableDiv>

      {isInfoProvided
        ? (
          <React.Fragment>
            {infoProvided?.article && (
            <ModifyOrderLine
              articleId={articleId}
              show={showEditModal}
              value={infoProvided?.article}
              onHide={() => setshowEditModal(false)}
              onSuccess={(id: number, article: OrderLine) => {
                setshowEditModal(false);
                onAccept(id, article);
              }}
            />
            )}
          </React.Fragment>
        )
        : (
          <EditDraftModal
            articleId={articleId}
            saveUpdate={false}
            show={showEditModal}
            onHide={() => setshowEditModal(false)}
            onSuccess={(id: number, article: OrderLine) => {
              setshowEditModal(false);
              onAccept(id, article);
            }}
          />
        )}
    </React.Fragment>
  );
};
